<template>
  <div>
    <modal
      v-model="active"
      title="Handla online"
    >
      <template #content>
        <div class="container-in-modal">
          <div class="content-modal">
            <p class="no-margin">
              På väg till e-handeln?
            </p>
            <p class="no-margin">
              Legitimera dig för att fortsätta handla och samla stammispoäng.
            </p>
          </div>
          <div class="buttons">
            <button
              type="button"
              class="button--primary button--48 button--fullwidth"
              @click="goToOnlineUrl"
            >
              Till e-handeln
            </button>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import modal from './storePickerModal/modal.vue'

export default {
	components: {
		modal
	},
  model: {
    prop: 'active',
    event: 'openstate'
  },
  props: {
		onlineUrl: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			active: true,
		}
	},
	watch: {
    active: function (newVal) {
      if (!newVal) {
        this.$emit('openstate', false)
				this.$emit('closeModal', false)
      }
    }
  },
	methods: {
    goToOnlineUrl () {
      window.location.href = this.onlineUrl+'/login?destination=%2F'
    },
		closeModal () {
			this.$emit('closeModal', false)
		}
	}
}

</script>

<style lang="scss">
.container-in-modal {
	text-align: center;
  padding: 0 40px;
	
	.content-modal {
		padding: 20px;
	}
  .no-margin {
    margin: 0;
  }
  .buttons {
    margin-top: 1rem;
  }
}
</style>
